import { Item } from '@/api/ms-item/services/interfaces';

export default (item: Item) => {
  return (
    !item.urlCache || (!item.urlCache.meta?.title && !item.urlCache.fetchStatus)
  );
};
